/*
 * Ajout au gramme depuis la collection (12/10/2026, Enzo).
 *
 * Le formulaire `form.pcv2__qa` (snippets/ajout-au-gramme.liquid) est un vrai
 * formulaire /cart/add : le poids coché part dans `id`. Ce script :
 *  - l'envoie sans quitter la page (POST /cart/add.js) ;
 *  - affiche « Ajout… » puis « Ajouté ✓ » sur le bouton ;
 *  - ouvre le tiroir panier (space-cart.js) et laisse son moteur du cadeau
 *    10 g GreenHouse, du franco et des points se recalculer, comme sur la fiche ;
 *  - affiche un message si Shopify refuse l'ajout (stock) ;
 *  - bloque le double toucher (un seul ajout par appui).
 *
 * L'écoute est posée UNE fois sur `window` (phase de capture) : elle passe donc
 * avant celle de space-cart.js, qui recevrait sinon le même formulaire et
 * l'ajouterait une deuxième fois. Les cartes sont remplacées par facets.js
 * (filtres, tri, pages) : aucune écoute n'est posée carte par carte.
 * Sans ce script, space-cart.js reçoit le formulaire et fait le même ajout.
 *
 * 13/10/2026 (Enzo) : le même formulaire sert aux autres rayons
 * (snippets/ajout-rapide.liquid : packs, puffs, cartouches, accessoires…).
 *  - Une seule variante : elle est dans un champ caché `id`, l'appui ajoute.
 *  - Plusieurs choix (saveur, couleur, taille…) : formulaire `.pcv2__qa--choix`.
 *    Les pastilles sont dans un panneau fermé, rien n'est coché : sur la carte
 *    on ne voit que « Ajouter », comme sur les autres. Le premier appui ouvre
 *    le panneau (classe `is-open`) ; toucher une pastille au doigt ou à la
 *    souris ajoute tout de suite ; au clavier, on choisit puis on valide avec
 *    « Ajouter ». Le panneau se referme après l'ajout, avec la croix, avec la
 *    touche Échap ou par un appui ailleurs sur la page.
 */
(function () {
  'use strict';

  if (window.__pcv2Qa) return;
  window.__pcv2Qa = true;

  var LIBELLE = 'Ajouter';

  function urlAjout() {
    var base = (window.SpaceCartConfig && window.SpaceCartConfig.addUrl) ||
      (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base + '.js';
  }

  function texteBouton(btn, txt) {
    var t = btn.querySelector('.pcv2__qa-add-txt');
    if (t) t.textContent = txt;
  }

  function message(msg, txt, visible) {
    if (!msg) return;
    msg.textContent = txt || '';
    if (visible) msg.classList.remove('visually-hidden');
    else msg.classList.add('visually-hidden');
  }

  // Efface le message après un délai ; un seul minuteur par formulaire.
  function effaceApres(form, msg, delai) {
    window.clearTimeout(form.__pcv2Fin);
    form.__pcv2Fin = window.setTimeout(function () { message(msg, '', false); }, delai);
  }

  function remetAZero(form, btn, delai) {
    window.setTimeout(function () {
      btn.classList.remove('is-loading');
      btn.classList.remove('is-added');
      btn.removeAttribute('aria-busy');
      texteBouton(btn, LIBELLE);
      form.removeAttribute('data-busy');
    }, delai);
  }

  function prendLeFocus(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (x) { el.focus(); }
  }

  // ---------- Panneau des choix (saveur, couleur, taille…) ----------
  function aChoix(form) {
    return !!(form && form.classList && form.classList.contains('pcv2__qa--choix'));
  }

  function ferme(form) {
    if (!aChoix(form)) return;
    form.classList.remove('is-open');
    var btn = form.querySelector('.pcv2__qa-add');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    var radios = form.querySelectorAll('.pcv2__qa-radio');
    for (var i = 0; i < radios.length; i++) radios[i].checked = false;
  }

  function ouvre(form) {
    var ouverts = document.querySelectorAll('form.pcv2__qa--choix.is-open');
    for (var i = 0; i < ouverts.length; i++) {
      if (ouverts[i] !== form) ferme(ouverts[i]);
    }
    form.classList.add('is-open');
    var btn = form.querySelector('.pcv2__qa-add');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    prendLeFocus(form.querySelector('.pcv2__qa-radio:not(:disabled)'));
  }

  // ---------- Ajout au panier ----------
  function ajoute(form) {
    if (form.getAttribute('data-busy') === '1') return;

    var radio = form.querySelector('input[name="id"]:checked') ||
      form.querySelector('input[type="hidden"][name="id"]');
    var btn = form.querySelector('.pcv2__qa-add');
    var msg = form.querySelector('.pcv2__qa-msg');
    if (!btn) return;

    if (!radio) {
      // Choix cachés : le premier appui sur « Ajouter » ouvre le panneau.
      if (aChoix(form) && !form.classList.contains('is-open')) {
        window.clearTimeout(form.__pcv2Fin);
        message(msg, '', false);
        ouvre(form);
        return;
      }
      // Panneau ouvert (ou pas de panneau) et rien de choisi : on le dit, on n'ajoute rien.
      message(msg, form.getAttribute('data-choisir') || 'Choisis d’abord une option.', true);
      effaceApres(form, msg, 6000);
      return;
    }

    // Navigateur trop ancien : envoi classique du formulaire.
    if (typeof window.fetch !== 'function' || typeof window.FormData === 'undefined') {
      HTMLFormElement.prototype.submit.call(form);
      return;
    }

    form.setAttribute('data-busy', '1');
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    texteBouton(btn, 'Ajout…');
    window.clearTimeout(form.__pcv2Fin);
    message(msg, '', false);

    window.fetch(urlAjout(), {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new window.FormData(form)
    })
      .then(function (r) {
        return r.json().then(
          function (j) { return { ok: r.ok, data: j || {} }; },
          function () { return { ok: r.ok, data: {} }; }
        );
      })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          var refus = new Error('refus');
          refus.description = res.data.description || res.data.message || '';
          throw refus;
        }
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        texteBouton(btn, 'Ajouté ✓');
        message(msg, 'Ajouté au panier.', false);
        // Choix cachés : le panneau se referme et plus rien n'est coché.
        ferme(form);
        try {
          if (window.SpaceCart && typeof window.SpaceCart.refresh === 'function') {
            window.SpaceCart.refresh(true);
          }
        } catch (x) { /* le tiroir se met aussi à jour tout seul : il observe les appels au panier */ }
        remetAZero(form, btn, 1800);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        var txt = (err && err.description) ||
          'Impossible d’ajouter ce produit pour le moment. Réessaie dans un instant.';
        message(msg, txt, true);
        remetAZero(form, btn, 300);
        effaceApres(form, msg, 6000);
      });
  }

  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('pcv2__qa')) return;

    // Ce formulaire est pris en charge ici, une seule fois.
    e.preventDefault();
    e.stopPropagation();

    ajoute(form);
  }, true);

  // Appui du doigt ou de la souris. Sur une pastille : on note l'instant, pour
  // savoir dans `change` que le choix vient d'un appui et pas du clavier.
  // Ailleurs que dans un panneau ouvert : ce panneau se referme.
  window.addEventListener('pointerdown', function (e) {
    var cible = e.target;
    if (!cible || !cible.closest) return;

    var ouverts = document.querySelectorAll('form.pcv2__qa--choix.is-open');
    for (var i = 0; i < ouverts.length; i++) {
      if (!ouverts[i].contains(cible)) ferme(ouverts[i]);
    }

    var opt = cible.closest('.pcv2__qa-opt');
    var form = opt ? opt.closest('form.pcv2__qa--choix') : null;
    if (form) form.__pcv2Appui = Date.now();
  }, true);

  window.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || !r.classList || !r.classList.contains('pcv2__qa-radio') || !r.form) return;
    var form = r.form;

    // Dès qu'un choix est fait, le message « Choisis d'abord… » n'a plus lieu d'être.
    window.clearTimeout(form.__pcv2Fin);
    message(form.querySelector('.pcv2__qa-msg'), '', false);

    // Choix cachés : une pastille touchée au doigt ou à la souris ajoute tout
    // de suite. Au clavier (flèches), on ne fait que choisir : c'est le bouton
    // « Ajouter » qui valide, sinon chaque flèche ajouterait un produit.
    if (aChoix(form) && form.classList.contains('is-open') &&
        form.__pcv2Appui && (Date.now() - form.__pcv2Appui) < 1500) {
      form.__pcv2Appui = 0;
      ajoute(form);
    }
  }, true);

  // La croix du panneau.
  window.addEventListener('click', function (e) {
    var cible = e.target;
    var croix = cible && cible.closest ? cible.closest('.pcv2__qa-fermer') : null;
    var form = croix ? croix.closest('form.pcv2__qa--choix') : null;
    if (!form) return;
    e.preventDefault();
    ferme(form);
    prendLeFocus(form.querySelector('.pcv2__qa-add'));
  }, true);

  // La touche Échap referme le panneau ouvert et rend la main au bouton.
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var form = document.querySelector('form.pcv2__qa--choix.is-open');
    if (!form) return;
    ferme(form);
    prendLeFocus(form.querySelector('.pcv2__qa-add'));
  }, true);
})();
